"use strict";

var cov_1mbtr9eswk = function () {
  var path = "/Users/jvvbsocianova/Projects/socianova/marty/src/constants.js",
      hash = "c01495ca85019af46e14a69508db9397c87607c4",
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/jvvbsocianova/Projects/socianova/marty/src/constants.js",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 0
        },
        end: {
          line: 3,
          column: 34
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

++cov_1mbtr9eswk.s[0];
angular.module('app').constant("API", "http://apps.preprod.socianova.net/marty/api/public").constant("BASE_HREF", "/marty/");